
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-account/billing/history",
      function () {
        return require("private-next-pages/my-account/billing/history.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-account/billing/history"])
      });
    }
  